import { useRouter } from "next/router"
import { MusinsaRegistrationPage } from "../../../components/signup/musinsa/MusinsaRegistrationPage"
import SMERegistrationPage from "../../../components/incheon/SMERegistrationPage"

export default function CreateAccount() {
  const router = useRouter()
  const { company } = router.query

  if (company === "musinsa") {
    return <MusinsaRegistrationPage />
  }

  if (company === "incheon") {
    return <SMERegistrationPage />
  }

  // default = incheon
  return <SMERegistrationPage />
}
